// extracted by mini-css-extract-plugin
export var blue = "_21-f";
export var brand = "_21-b";
export var darkGrey = "_21-e";
export var disabled = "_21-4";
export var disabledSubtle = "_21-5";
export var error = "_21-6";
export var green = "_21-g";
export var grey = "_21-d";
export var icon = "_21-0";
export var inherit = "_21-a";
export var lightGrey = "_21-c";
export var orange = "_21-i";
export var pink = "_21-k";
export var primary = "_21-1";
export var purple = "_21-l";
export var red = "_21-j";
export var secondary = "_21-2";
export var success = "_21-9";
export var tertiary = "_21-3";
export var warning = "_21-7";
export var warningSecondary = "_21-8";
export var white = "_21-m";
export var yellow = "_21-h";